import DriverDto from 'app/admin/driver/dto/DriverDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class OutlierDetectorTableDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;
	}

	/**
	 * @typedef {Object} _OutlierDetectorTableDtoProps
	 * @property {string} type
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OutlierDetectorTableDtoProps} OutlierDetectorTableDtoProps
	 */
	/**
	 *
	 * @param {OutlierDetectorTableDtoProps} props
	 * @returns {OutlierDetectorTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;

		return this;
	}
}

export default OutlierDetectorTableDto;